import React from 'react';
import ReactDOM from 'react-dom/client';
import Locales from './assets/const/locales';
import { WidgetNames } from './widgets';
import App from './App';

if (process.env.NODE_ENV === 'development') {
  // development
   const content = WidgetNames.typeAhead;
  // const content = WidgetNames.typeAheadMobile;
  // const content = WidgetNames.listing;
  //const content = WidgetNames.searchResults;


  const initialParams = {
    // language params:
    // isSingleAsset : "false",
    // currentTaxId : "12352333",
    // currentAsset : '',
    // billingAccount : '',
    // page : 'shop',
    // categoryIdList: "112,113,114",
    // categoryNameList: "kinita}all_smartphones}Gaming",
    // searchQuery: "smartphones",
    categoryIdList: "112,113,114",
    categoryNameList: "kinita}all_smartphones}Gaming",
    searchQuery: "smartphones",
    locale: Locales.GREEK,
      // q: "realme 12x",
      // collectionSet: "products",
      // filter: [],
      // size: 12,
      // order: "score",
      // page: 1,
      // language: "en",
      // flow: "searchResults"

    // check assets::const::locales for locale values
    // check utils::localeUtils::constants::supportedLocales for supported locales
    // if locale not set then defaults to utils::localeUtils::constants::defaultLocale
    // if locale is not supported then defaults to utils::localeUtils::constants::defaultFallbackLocale

    // widget params:
    // assetNumber: '300000000810413',
  };
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <App content={content} initialParams={initialParams} />
    </React.StrictMode>
  );
} else {
  // production
  Object.values(WidgetNames).forEach((widgetName) => {
    const element = document.getElementById(widgetName);
    if (element != null) {
      ReactDOM.createRoot(element).render(<App content={widgetName} initialParams={element.dataset ?? {}} />);
    }
  });
}
